<template>
  <div class="form-v1">
    <v-layout>
      <v-flex md9>
        <impacted_area_details_row
          v-for="(v,i) in selected_item.impacted_area_details"
          :key="i"
          :selected_item="v"
          :view_only="view_only"
          :current_fiscal_year="current_fiscal_year"
        />

      </v-flex>
      <v-flex md3>
        <v-layout>
          <v-flex md9>
            Resultado (en MUSD BHP Share)
          </v-flex>
          <v-flex md3 v-if="!view_only" style="text-align: right">
            <slot></slot>
          </v-flex>
        </v-layout>
        
        <div class="valueContainer" style="text-align: right" :style="`height:${(78*selected_item.impacted_area_details.length)-40}px`">
          <span style="margin: 0;position: relative;top: 45%;">{{fix(financial_loss)}}</span>
        </div>
      </v-flex>
    </v-layout>

    <static_loss_compositions :items="selected_item.static_loss_compositions" :view_only="view_only"/>
    <div class="form-v1">
      <v-layout>
        <v-flex md9></v-flex>
        <value-container md="3" label="Resultado MFL financiero (total causa)" :value="t_financial_loss" class="text_align_right"/>
      </v-layout>
    </div>
  </div>
</template>

<script>
import impacted_area_details_row from './impacted_area_details_row.vue';
import static_loss_compositions from './static_loss_compositions.vue';
import in_impacted_areas from '@/components/inputs/impacted_areas.vue';
import { computed_financial_mfl} from '@/functions/general.js';
export default {
  props: ['official_fiscal_year','selected_item','view_only','numero_modo_falla','numero_composicion_perdida','impacted_areas'],
  components:{ in_impacted_areas, static_loss_compositions,impacted_area_details_row},
  data() {
    return {
      
    };
  },
  computed: {
    t_financial_loss(){
      return Math.floor((this.financial_loss
        +
        this.selected_item.static_loss_compositions
          .map(m=>m.financial_loss)
          .reduce((prev, curr) => prev + curr, 0)) * 100) / 100
    },
    ebits() { return this.$store.getters.ebits },
    current_fiscal_year(){ return (this.$store.getters.current_fiscal_year ||{}).year },
    fiscal_year() { return this.official_fiscal_year || this.current_fiscal_year },
		c_ebits() { return this.ebits.filter(f => f.fiscal_year == this.current_fiscal_year)},
    ebit(){
      return this.selected_item.ebit = this.c_ebits
        .filter(e => this.selected_item.impacted_areas.includes(e.impacted_area))
        .map(m=>m.value)
        .reduce((prev, curr) => prev + curr, 0)
    },
    financial_loss(){
      return this.selected_item.financial_loss =  this.selected_item.impacted_area_details
        .map(v => computed_financial_mfl({
          asset:{ mfl_days: v.mfl_days, impact_percentage: v.impact_percentage },
          ebit: this.get_ebit(v.impacted_area)
        }))
        .reduce((prev, curr) => prev + curr, 0);
    },
  },
  watch: {
    impacted_areas(){
      this.set_impacted_area();
    }
  },
  created() {
    this.set_impacted_area();
  },
  methods: {
    get_ebit(id){ return (this.c_ebits.find(e => id === e.impacted_area)||{}).value },
    set_impacted_area(){
      this.selected_item.impacted_areas = this.impacted_areas;
      const impacted_area_details = [];
      
      this.impacted_areas.forEach(impacted_area => {
        const iad = this.selected_item.impacted_area_details.find(f=>f.impacted_area===impacted_area);
        impacted_area_details.push(iad||{impact_percentage:0,impacted_area,mfl_days:0});
      });
      /* const l = this.selected_item.impacted_area_details.length;
      for (let i = 0; i < l; i++) this.selected_item.impacted_area_details.pop();
      impacted_area_details.forEach(v=>this.selected_item.impacted_area_details.push(v)) */
      this.selected_item.impacted_area_details = impacted_area_details;
    }
  }, // methods
};
</script>

<style scoped>
.spbt>.layout>.flex {
  padding-right: 24px;
  padding-left: 24px;
}
.spbt>.layout>.flex:nth-of-type(1) {
  padding-right: 24px;
  padding-left: 0;
}
.spbt>.layout>.flex:nth-last-of-type(1) {
  padding-right: 24px;
  padding-left: 0;
}
</style>